import type {
  CrremCorrectionFlags,
  CrremPathwayPartitionBy,
  CrremPathwayScale,
  CrremPathwayStoredConfig,
  CrremPathwayViewSettings,
} from "./types";

export const CORRECTION_FLAG_ICONS = {
  climate: "Sun",
  coverage: "Eyeglasses",
  vacancy: "People",
} as const;

export const CRREM_CHART_EXCLUDED_SERIES = {
  baseline: "baseline",
  corrected: "corrected",
};

export const CRREM_PATHWAY_PARTITION_BY: Record<CrremPathwayPartitionBy, CrremPathwayPartitionBy> = {
  none: "none",
  useType: "useType",
  utility: "utility",
};

export const CRREM_PATHWAY_SCALE: Record<CrremPathwayScale, CrremPathwayScale> = {
  grossArea: "grossArea",
  netLettableArea: "netLettableArea",
  none: "none",
};

export const DEFAULT_CRREM_PATHWAY_VIEW: CrremPathwayViewSettings = {
  displayMetric: "co2",
  partitionBy: CRREM_PATHWAY_PARTITION_BY.none,
  scale: CRREM_PATHWAY_SCALE.none,
  visibleCorrectionIds: [],
};

export const DEFAULT_CRREM_PATHWAY_CONFIG: CrremPathwayStoredConfig = {
  ...DEFAULT_CRREM_PATHWAY_VIEW,
  trendMethod: "average",
};

export const isExcludedCrremChartSeries = (key: string) =>
  key === CRREM_CHART_EXCLUDED_SERIES.baseline || key === CRREM_CHART_EXCLUDED_SERIES.corrected;

export const isBaselineCorrections = (corrections: CrremCorrectionFlags) =>
  !corrections.climate && !corrections.coverage && !corrections.vacancy;

export const isClimateOnlyCorrections = (corrections: CrremCorrectionFlags) =>
  corrections.climate && !corrections.coverage && !corrections.vacancy;

export const correctionFlagCount = (corrections: CrremCorrectionFlags) =>
  Number(corrections.coverage) + Number(corrections.climate) + Number(corrections.vacancy);

const CORRECTION_OPTION_ORDER = ["010", "001", "011", "100", "110", "101", "111"] as const;

export const correctionOptionOrder = (corrections: CrremCorrectionFlags) => {
  const key = `${corrections.coverage ? "1" : "0"}${corrections.climate ? "1" : "0"}${corrections.vacancy ? "1" : "0"}`;
  const index = CORRECTION_OPTION_ORDER.findIndex((item) => item === key);
  return index < 0 ? CORRECTION_OPTION_ORDER.length : index;
};

export const correctionIconNames = (corrections: CrremCorrectionFlags) =>
  (["coverage", "climate", "vacancy"] as const)
    .filter((key) => corrections[key])
    .map((key) => CORRECTION_FLAG_ICONS[key]);
